import { LayerData } from "../../modules/createV3/layers/layerData.model";
import { MediaFile } from "./mediaFile.model";
import { Thumbnail } from "./thumbnail.model";

export class AdTemplate {
  id: number;
  name: string;
  type: "Template";
  thumbnail: Thumbnail | null;
  media: MediaFile | null;
  composition_layer: LayerData | null;
  is_default: boolean;
  is_static: boolean;
  copy_text: string;
  children: AdTemplate[];
  link_headline: string;
  link_description: string;
  link: string;
  cta_text: string;
  constructor(data?: Partial<AdTemplate>) {
    this.id = data?.id || -1;
    this.thumbnail = data?.thumbnail || null;
    this.type = "Template";
    this.name = data?.name || "";
    this.media = data?.media || null;
    this.composition_layer = data?.composition_layer || null;
    this.is_static = data?.is_static || false;
    this.children = data?.children || [];
    this.is_default = data?.is_default || false;
    this.copy_text = data?.copy_text || "";
    this.link_headline = data?.link_headline || "";
    this.link_description = data?.link_description || "";
    this.link = data?.link || "";
    this.cta_text = data?.cta_text || "";
  }
}
